var render = function render(){var _vm=this,_c=_vm._self._c;return _c('article',{staticClass:"level"},[_c('span',{staticClass:"level-chip"},[_vm._v(" "+_vm._s(_vm.level.name))]),_c('div',{staticClass:"level-counter"},[_vm._v(_vm._s(_vm.level.rounds)+" rounds")])])
}
var staticRenderFns = []

export { render, staticRenderFns }